import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useStore } from '@hooks';
import { Loader } from '@ui';
import { observer } from 'mobx-react';
import AuthLayout from '../../layouts/AuthLayout';
import Confirmed from './components/Confirmed';
import Rejected from './components/Rejected';
import { StyledText } from './styled';

const InviteeUser = observer(() => {
    const store = useStore();
    const { verifyToken } = store.accountsStore;

    const [loading, setLoading] = useState(true);

    const [searchParams] = useSearchParams();
    const action = searchParams.get('action');
    const token = searchParams.get('token');

    const confirmed = action === 'confirm-invite';
    const rejected = action === 'reject-invite';

    const [tokenError, setTokenError] = useState(null);

    useEffect(() => {
        (async () => {
            if ((confirmed || rejected) && token) {
                const result = await verifyToken(token);
                // Check if there was an error returned from the action
                if (result?.error) {
                    const errorCode = result.error?.response?.data?.code;
                    setTokenError(errorCode);
                }
                setLoading(false);
            }
        })();
    }, []);

    if (loading) {
        return <Loader />;
    }

    const { error } = store;

    if (error || tokenError) {
        const isTokenUsed = tokenError === 'TOKEN_USED';

        return (
            <AuthLayout
                description={
                    <StyledText>
                        {isTokenUsed ? (
                            <React.Fragment>
                                This invitation link has already been used. If you previously declined this invitation
                                and would like to accept it, please request a new invitation from the store owner.
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                Hi, It seems there might be an issue with the invitation link you used. To gain access,
                                please request a new invitation from the store owner.
                            </React.Fragment>
                        )}
                    </StyledText>
                }
                leftCol=''
                title='Create Staff Account'
            />
        );
    }

    if (confirmed) {
        return <Confirmed token={token} />;
    }

    if (rejected) {
        return <Rejected token={token} />;
    }

    return null;
});

export default InviteeUser;
